import {
  REQUEST_SELLER_LISTINGS,
  RECEIVE_SELLER_LISTINGS,
  BOOST_LISTING,
  MARK_LISTING_AS_SOLD,
  UNMARK_LISTING_AS_SOLD,
  RESERVE_LISTING,
  UNRESERVE_LISTING,
  CANCEL_LISTING,
  RELIST_LISTING,
  UNMARK_LISTING_AS_STALE,
  CHECK_RELISTED_LISTING,
  SET_ERROR_STATE,
  SET_SELLER_ID
} from 'constants/ActionTypes'

const listingsReducer = (state = initialListingsState, action) => {
  switch (action.type) {
    case SET_SELLER_ID:
      return Object.assign({}, state, {
        sellerId: action.sellerId
      })
    case REQUEST_SELLER_LISTINGS:
      return Object.assign({}, state, {
        success: true
      })
    case RECEIVE_SELLER_LISTINGS:
      if (action.page >= 2) {
        const listings = state.listings.concat(action.listings)
        const uniqListings = Array.from(new Set(listings.map(l => l.id))).map(id => {
          return listings.find(item => item.id === id)
        })
        return Object.assign({}, state, {
          listings: uniqListings,
          nbOfListings: action.nbOfListings,
          nbOfListingsCapped: action.nbOfListingsCapped,
          hasMore: action.hasMore,
          success: action.success
        })
      } else {
        return Object.assign({}, state, {
          listings: action.listings,
          nbOfListings: action.nbOfListings,
          nbOfListingsCapped: action.nbOfListingsCapped,
          hasMore: action.hasMore,
          success: action.success
        })
      }
    case BOOST_LISTING:
      return Object.assign({}, state, {
        success: action.success,
        listings: state.listings.map(listing => {
          if (listing.id !== action.listing.id) {
            return listing
          }

          return { ...listing, ...action.listing }
        }),
        nbOfListings: action.nbOfListings
      })
    case MARK_LISTING_AS_SOLD:
      return Object.assign({}, state, {
        success: action.success,
        listings: state.listings.map(listing => {
          if (listing.id !== action.listing.id) {
            return listing
          }

          return Object.assign({}, listing, {
            status: action.listing.status
          })
        }),
        nbOfListings: action.nbOfListings
      })
    case UNMARK_LISTING_AS_SOLD:
      return Object.assign({}, state, {
        success: action.success,
        listings: state.listings.map(listing => {
          if (listing.id !== action.listing.id) {
            return listing
          }

          return Object.assign({}, listing, {
            status: action.listing.status
          })
        })
      })
    case RESERVE_LISTING:
      return Object.assign({}, state, {
        success: action.success,
        listings: state.listings.map(listing => {
          if (listing.id !== action.listing.id) {
            return listing
          }

          return Object.assign({}, listing, {
            status: action.listing.status
          })
        }),
        nbOfListings: action.nbOfListings
      })
    case UNRESERVE_LISTING:
      return Object.assign({}, state, {
        success: action.success,
        listings: state.listings.map(listing => {
          if (listing.id !== action.listing.id) {
            return listing
          }

          return Object.assign({}, listing, {
            status: action.listing.status
          })
        }),
        nbOfListings: action.nbOfListings
      })
    case CANCEL_LISTING:
      // A cancelled (deleted) listing leaves the dashboard entirely, so drop it
      // from state rather than updating its status.
      return Object.assign({}, state, {
        success: action.success,
        listings: state.listings.filter(listing => listing.id !== action.id),
        nbOfListings: action.nbOfListings
      })
    case RELIST_LISTING:
      return Object.assign({}, state, {
        success: action.success,
        listings: state.listings.map(listing => {
          if (listing.id !== action.listing.id) {
            return listing
          }

          return Object.assign({}, listing, {
            isBeingRelisted: action.listing.isBeingRelisted
          })
        }),
        nbOfListings: action.nbOfListings
      })
    case CHECK_RELISTED_LISTING:
      if (action.relisted) {
        return Object.assign({}, state, {
          listings: action.listings,
          success: true,
          nbOfListings: action.nbOfListings,
          nbOfListingsCapped: action.nbOfListingsCapped,
          hasMore: action.hasMore
        })
      } else {
        return Object.assign({}, state, {
          listings: state.listings,
          success: true
        })
      }
    case UNMARK_LISTING_AS_STALE:
      return Object.assign({}, state, {
        success: action.success,
        listings: state.listings.map(listing => {
          if (listing.id !== action.listing.id) {
            return listing
          }

          return Object.assign({}, listing, {
            status: action.listing.status
          })
        }),
        nbOfListings: action.nbOfListings
      })
    case SET_ERROR_STATE:
      return Object.assign({}, state, {
        success: false,
        error: action.error
      })
    default:
      return state
  }
}

const initialListingsState = {
  listings: [],
  nbOfListings: 0,
  // True when the server capped the count - the real total is higher.
  nbOfListingsCapped: false,
  // Whether the last page fetched was full, i.e. more pages may exist.
  hasMore: false,
  success: false,
  // Set when an admin is viewing the dashboard as a specific seller. When
  // present it is appended to the GET listing requests as `id`.
  sellerId: null
}

export default listingsReducer
